import React, { ChangeEvent, ComponentProps, FC } from "react";
import { styled } from "../stitches.config";
import { stitchesSelectStyles } from "../stitches/select";

const StyledSelect = styled("select", stitchesSelectStyles);
export interface SelectProps extends ComponentProps<"div"> {
  /** Provide a text content for the card */
  defaultOption?: string;
  isSelected: string | number;
  options: any[];
  onSelectChange: (e: ChangeEvent<HTMLSelectElement>) => void;
}

export const Select: FC<SelectProps> = ({ options, isSelected, onSelectChange, defaultOption, ...props }) => {
  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        minWidth: "100px",
        maxWidth: "220px",
        display: "flex",
        flex: "1 1 0%",
        alignItems: "center",
      }}
      {...props}
    >
      <StyledSelect onChange={onSelectChange}>
        {defaultOption && (
          <option selected disabled>
            {defaultOption}
          </option>
        )}
        {options.map((option, i) => (
          <option selected={isSelected === options[i]} value={options[i]}>
            {option}
          </option>
        ))}
      </StyledSelect>
    </div>
  );
};
